import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { url: String }

  connect() {
    this.load()
  }

  load() {
    if (!this.hasUrlValue || !this.hasContentTarget) return

    fetch(this.urlValue, {
      headers: { Accept: "text/html" },
      credentials: "same-origin"
    })
      .then((response) => {
        if (!response.ok) throw new Error("tables_load_failed")

        return response.text()
      })
      .then((html) => {
        this.contentTarget.innerHTML = html
      })
      .catch(() => {
        this.contentTarget.innerHTML = "<div class=\"aia-empty-state\">Impossible de charger les tableaux de validation.</div>"
      })
  }
}
